/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryAssessmentApprover extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryAssessmentApprover");
    }

    getFixupPrototypeFunction() { return AssessmentQueryAssessmentApprover.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryAssessmentApprover>): AssessmentQueryAssessmentApprover {
        let obj = Object.assign(new AssessmentQueryAssessmentApprover(), model);
        AssessmentQueryAssessmentApprover.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryAssessmentApprover>): AssessmentQueryAssessmentApprover {
        if (!model) return null;
        return AssessmentQueryAssessmentApprover.newInstance(<AssessmentQueryAssessmentApprover> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryAssessmentApprover) {
        if (!obj) return;

        models.AssessmentQueryAssessmentApprover.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryAssessmentApprover): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryAssessmentApprover.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Approvers of assessment
     */
    assessment_approvers: Array<string>;

}
